module.exports = __webpack_public_path__ + "static/media/bg-4.c991b301.png";